import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../../common/tab/tabActions';

const INITIAL_VALUES = { ativo: '1', equipe_id: '' };

export { selectTab };

export function getList() {
  const request = axiosInstance.get('/manutencao/viaturas');
  return {
    type: 'VIATURA_FETCHED',
    payload: request,
  };
}

export function getOpcoes() {
  return dispatch => {
    axiosInstance
      .get('/manutencao/opcoes')
      .then(resp => dispatch({ type: 'VIATURA_OPCOES_FETCHED', payload: { equipes: resp.data.equipes || [] } }))
      .catch(() => toastr.error('Erro', 'Não foi possível carregar as equipes.'));
  };
}

export const setPaginaAtual = pagina => ({
  type: 'VIATURA_PAGE',
  payload: pagina,
});

function normalize(values) {
  return {
    ...values,
    equipe_id: values.equipe_id ? parseInt(values.equipe_id, 10) : null,
    ativo: parseInt(values.ativo, 10) === 1,
  };
}

export function create(values) {
  return submit(normalize(values), 'post');
}

export function update(values) {
  return submit(normalize(values), 'put');
}

export function remove(values) {
  return dispatch => {
    axiosInstance
      .delete(`/manutencao/viaturas/${values.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Viatura removida com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível remover a viatura.');
      });
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url = method === 'put' ? `/manutencao/viaturas/${id}` : '/manutencao/viaturas';
    axiosInstance[method](url, values)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar a viatura.');
      });
  };
}

export function showUpdate(viatura) {
  return [
    showTabs('tabUpdate'),
    selectTab('tabUpdate'),
    initialize('viaturaForm', {
      ...viatura,
      equipe_id: viatura.equipe_id ? String(viatura.equipe_id) : '',
      imei: viatura.imei || '',
      ativo: viatura.ativo ? '1' : '0',
    }),
  ];
}

export function init() {
  return dispatch => {
    dispatch(getOpcoes());
    dispatch(showTabs('tabList', 'tabCreate'));
    dispatch(selectTab('tabList'));
    dispatch(getList());
    dispatch(initialize('viaturaForm', INITIAL_VALUES));
  };
}
